import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

export const checkConferenceCallPermissions = (groupId: string): boolean => {
  const group = Entities.GroupsStore.getGroupById(groupId);

  if (!group) {
    return false;
  }

  const hasAudioPermissions = Tasks.calls.checkIsAvailableCall(group);

  if (!hasAudioPermissions) {
    return false;
  }

  if (!group?.canInitConference) {
    Tasks.app.showAlert(t('no_permission_alert'));

    return false;
  }

  return true;
};
